<template>
    <div id="customerAddModal" class="modal fade add-customer-popup" ref="customerAddModal">
        <div class="modal-dialog modal-confirm modal-dialog-scrollable" style="max-width: 1140px;">
            <div class="modal-content">
                <div class="modal-header p-3 bg-soft-info">
                    <div class="icon-box">

                    </div>
                    <h4 class="modal-title">Create Customer</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i  class="ri-close-line"></i></button>
                </div>
                <div class="modal-body">
                    <div class="add-customer-section">

                        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                            <form @submit.prevent="handleSubmit(save)" id="addCustomerForm" name="addCustomerForm" method="post">
                                <div class="new-rfq">
                                    <div class="row">
                                        <div class="alert alert-success succ_msg" v-if="successMessage !=null">
                                            <strong class="success_msg">{{successMessage}}</strong>
                                        </div>
                                        <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                                            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                            <ul>
                                                <li v-for="(v, k) in commonErrors" :key="k">
                                                    <p v-for="error in v" :key="error" class="text-sm">
                                                        {{ error }}
                                                    </p>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-lg-12 col-md-12">
                                            <div class="panel create-box border mb-3">

                                                <div class="card-body">
                                                    <h2 class="mb-3 inner-title">Company Information</h2>
                                                    <div class="row">
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                    <label>Company Name</label>
                                                                    <input type="text" class="form-control" name="company_name" placeholder="" v-model="form.company_name">
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                </validation-provider>
                                                            </div>
                                                        </div>
                                                        
                                                        <template v-if="po_box">
                                                            <div class="form-group flex-fill">
                                                                <label>Company Address</label>
                                                                <input type="text" class="form-control" 
                                                                       @focus="isModalOpen=true"
                                                                       name="address" placeholder="Company Address" v-model="form.address">
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                        <GooglePlaceAutoComplete v-if="isModalOpen"
                                                                                     :title="'Company Address'"
                                                                                     :placeholder="'Company Address'"
                                                                                     :errors="null"
                                                                                     v-model="form.address"
                                                                                     @selectedEvent="selectCompanyAddress"></GooglePlaceAutoComplete>
                                                        </template>
                                                        <!-- <div class="col-lg-3 col-md-6 ">
                                                            
                                                            <div class="form-group flex-fill">
                                                                <label>Company Address</label>
                                                                <input type="text" class="form-control" v-if="!isModalOpen"
                                                                       @focus="isModalOpen=true"
                                                                       name="address" placeholder="Company Address" v-model="form.address">
                                                            </div>
                                                        </div> -->

                                                        <div class="col-lg-2 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Country</label>
                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                    <select class="form-control" id="country_id1" name="country_id" v-model="form.country_id">
                                                                        <option value="null">Select Country</option>
                                                                        <option v-for="country in countries" :value="country.id">{{country.name}}</option>
                                                                    </select>
                                                                    <span class="error">{{ errors[0] }}</span>
                                                                </validation-provider>
                                                            </div>
                                                        </div>
                                                        
                                                        <div class="col-lg-2 col-md-6 ">
                                                        <div class="form-group flex-fill">
                                                            <label for="contact_email" class="control-label">City </label>
                                                            
                                                            <input type="text" class="form-control" id="shipping_city" name="shipping_city" v-model="form.city">
                                                        </div>
                                                            

                                                        </div>
                                                        <div class="col-lg-2 col-md-6 ">
                                                        <div class="form-group flex-fill">
                                                            <label for="contact_email" class="control-label">State </label>
                                                            <input type="text" class="form-control" id="shipping_state" name="shipping_state" v-model="form.state">
                                                        </div>
                                                            

                                                        </div>
                                                        <div class="col-lg-2 col-md-6 ">
                                                        <div class="form-group flex-fill">
                                                            <label for="contact_email" class="control-label">Zip </label>
                                                            <input type="text" class="form-control" id="shipping_zip" name="shipping_zip" v-model="form.post_code">
                                                        </div>
                                                            

                                                        </div>
                                                        
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Website</label>
                                                                <input type="text" class="form-control" placeholder="" name="website" id="website" v-model="form.website" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-2 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Fax</label>
                                                                <input type="text" class="form-control" placeholder="" name="fax" id="fax" v-model="form.fax" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-2 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Phone</label>
                                                                <input type="text" class="form-control" placeholder="" name="fax" id="phone" v-model="form.phone" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Email</label>
                                                                <input type="email" class="form-control" placeholder="" name="email" id="email" v-model="form.email" />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3 col-md-6 ">
                                                            <div class="form-group flex-fill">
                                                                <label>Sales Rep</label>
                                                                <select class="form-control" id="country_id" name="country_id" v-model="form.sales_rep_id">
                                                                    <option value="" selected>Select Sales Rep</option>
                                                                    <option v-for="salesRep in salesRep.data" :value="salesRep.id">{{salesRep.name}}</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                            <div class="form-group gap-top d-flex">
                                                                <input type="checkbox" v-model="form.po_box"
                                                                        name="default"  @change="checkStatus($event)" >
                                                                <label for="status" class="mdl-textfield__label">PO Box</label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="panel border mb-3">
                                                <div class="card-body">
                                                    <div class="add-container">
                                                        <h2 class="inner-title">Contact</h2>
                                                        <div class="product-create">
                                                            <div id="email_alert" class="alert alert-danger" style="display: none;">
                                                                <strong>Please fill out * fields</strong>
                                                            </div>
                                                            <div class="plus-iconadd dff-pos" width="25px;">
                                                                <button class="btn btn-info  px-3" style="margin-top: -5px" @click="addNewContact()"
                                                                        alt="plus-icon"><i class="ri-add-circle-line align-middle"></i> Add New
                                                                </button>
                                                            </div>
                                                            <div class="add_new_contact">
                                                                <template v-for="(contact, index) in form.contacts">


                                                                    <div class="contact-dtlbox">
                                                                        <div class="row count_contact contact_1">
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                                    <div class="form-group">
                                                                                        <label for="contact_name" class="control-label">Full
                                                                                            Name </label>
                                                                                        <input type="text" class="form-control" id="contact_name"
                                                                                               name="contact_name" v-model="contact.contact_name">
                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </div>

                                                                                </validation-provider>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <validation-provider rules="required|email" v-slot="{ errors }">
                                                                                    <div class="form-group">
                                                                                        <label for="contact_email" class="control-label">Email </label>
                                                                                        <input type="email" class="form-control" id="contact_email"
                                                                                               name="contact_email" v-model="contact.contact_email">

                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </div>
                                                                                </validation-provider>

                                                                            </div>
                                                                            <template
                                                                                v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                                                                                     v-if="contactIndex == 0">
                                                                                    <div class="form-group cmbne-sel-inpt">
                                                                                        <label>&nbsp;</label>
                                                                                        <div class="add-contact">
                                                                                            <select class="form-control select-control"
                                                                                                    name="contact_phn_type"
                                                                                                    v-model="contact_number.contact_phn_type">
                                                                                                <option value="Mobile">Mobile</option>
                                                                                                <option value="Office">Office</option>
                                                                                            </select>
                                                                                            <validation-provider name="Phone" rules="required"
                                                                                                                 v-slot="{ errors }">
                                                                                                <input type="text" class="form-control contact_no"
                                                                                                       name="contact_phone_no"
                                                                                                       v-model="contact_number.contact_phone_no"/>
                                                                                                <span class="error">{{ errors[0] }}</span>
                                                                                            </validation-provider>
                                                                                            <div class="action-btn">
                                                                                                <div v-if="contactIndex == 0"
                                                                                                     class="btn btn-primary"
                                                                                                     @click="addNewNumber(index)" alt="plus-icon"><i
                                                                                                    class="ri-add-circle-line"></i></div>
                                                                                                <a v-if="contactIndex > 0" class="minus-icon"
                                                                                                   @click="removeNumber(index, contactIndex)"
                                                                                                   href="javascript:void(0);"><i
                                                                                                    class="fas fa-minus-circle"></i></a>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>


                                                                            </template>


                                                                        </div>

                                                                        <div class="contact_row_1 number_row">
                                                                            <div class="row">
                                                                                <template
                                                                                    v-for="(contact_number, contactIndex) in contact.contact_numbers">
                                                                                    <div v-if="contactIndex> 0"
                                                                                         class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                        <div class="contact_row_1 number_row">
                                                                                            <div>
                                                                                                <div class="form-group cmbne-sel-inpt">
                                                                                                    <div class="add-contact">
                                                                                                        <select class="form-control select-control"
                                                                                                                name="contact_phn_type"
                                                                                                                v-model="contact_number.contact_phn_type">
                                                                                                            <option value="Mobile">Mobile</option>
                                                                                                            <option value="Office">Office</option>
                                                                                                        </select>
                                                                                                        <validation-provider rules="required"
                                                                                                                             v-slot="{ errors }">
                                                                                                            <input type="text"
                                                                                                                   class="form-control contact_no"
                                                                                                                   name="contact_phone_no"
                                                                                                                   v-model="contact_number.contact_phone_no"/>
                                                                                                            <span class="error">{{
                                                                                                                    errors[0]
                                                                                                                }}</span>
                                                                                                        </validation-provider>
                                                                                                        <div class="action-btn">
                                                                                                            <div v-if="contactIndex == 0"
                                                                                                                 class="plus-icon"
                                                                                                                 @click="addNewNumber(index)"
                                                                                                                 alt="plus-icon"><i
                                                                                                                class="fas fa-plus"></i></div>
                                                                                                            <a v-if="contactIndex > 0"
                                                                                                               class="btn btn-danger remove"
                                                                                                               @click="removeNumber(index, contactIndex)"
                                                                                                               href="javascript:void(0);"><i
                                                                                                                class="ri-delete-bin-6-line"></i></a>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>

                                                                                </template>
                                                                            </div>
                                                                        </div>

                                                                        <div class="row">


                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <label for="role" class="mdl-textfield__label">Role </label>
                                                                                    <input type="text" v-model="contact.contact_role" name="role" id="role"
                                                                                           class="form-control">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <label for="status"
                                                                                           class="mdl-textfield__label">Status </label>
                                                                                    <select class="form-control mdl-textfield__input"
                                                                                            id="status" name="status" v-model="contact.status">
                                                                                        <option value="1">Active</option>
                                                                                        <option value="2">InActive</option>
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                                        <label for="status" class="mdl-textfield__label">Contact
                                                                                            Types </label>

                                                                                        <v-select label="name" :filterable="true"
                                                                                                  v-model="contact.contact_types"
                                                                                                  :options="contactTypes"
                                                                                                  multiple taggable
                                                                                                  @input="onContactTypeSelect($event, index)"
                                                                                                  @selected="onContactTypeSelect($event, index)"
                                                                                                  @deselected ="onContactTypeDeSelect($event, index)">
                                                                                            <template slot="no-options">
                                                                                                type to search contact types..
                                                                                            </template>
                                                                                            <template slot="option" slot-scope="option">
                                                                                                <div class="d-center" v-html="option.name">
                                                                                                </div>
                                                                                            </template>
                                                                                            <template slot="selected-option" slot-scope="option">
                                                                                                <div class="selected d-center" v-html="option.name">
                                                                                                </div>
                                                                                            </template>
                                                                                        </v-select>
                                                                                        <!--<select class="form-control mdl-textfield__input"
                                                                                                id="contact_type_ids" name="status"
                                                                                                v-model="contact.contact_type_ids" :multiple="true">
                                                                                            <option v-for="(contactType) in contactTypes"
                                                                                                    :value="contactType.id">{{ contactType.name }}
                                                                                            </option>
                                                                                        </select>-->
                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </validation-provider>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group gap-top d-flex">
                                                                                    <input type="checkbox" v-model="contact.default_contact"
                                                                                           name="default" value="" @change="checkDefault(index)">
                                                                                    <label for="status" class="mdl-textfield__label">Default
                                                                                        Contact </label>


                                                                                    <div class="action-btn ms-sm-auto">
                                                                                        <a v-if="index > 0" class="remove-icon"
                                                                                           @click="removeContact(index)" href="javascript:void(0);"><i
                                                                                            class="ri-delete-bin-6-line"></i></a>

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </template>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Billing Contact starts -->
                                            <!--<div class="panel border mb-3">
                                                <div class="card-body">
                                                    <div class="add-container">
                                                        <h2 class="inner-title">Billing Contact</h2>
                                                        <div class="product-create">
                                                            <div id="email_alert" class="alert alert-danger" style="display: none;">
                                                                <strong>Please fill out * fields</strong>
                                                            </div>
                                                            <div class="plus-iconadd dff-pos" width="25px;">
                                                                <button class="btn btn-info  px-3" style="margin-top: -5px"
                                                                        @click="addNewContactBilling()" alt="plus-icon"><i
                                                                    class="ri-add-circle-line align-middle"></i> Add New
                                                                </button>
                                                            </div>
                                                            <div class="add_new_contact">
                                                                <template v-for="(billing, index) in form.billing">


                                                                    <div class="contact-dtlbox">
                                                                        <div class="row count_contact contact_1">
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <validation-provider rules="required" v-slot="{ errors }">
                                                                                    <div class="form-group">
                                                                                        <label for="contact_name" class="control-label">Full
                                                                                            Name </label>
                                                                                        <input type="text" class="form-control" id="billing_name"
                                                                                               name="billing_name" v-model="billing.contact_name">
                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </div>

                                                                                </validation-provider>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <label for="contact_email" class="control-label">Email </label>
                                                                                    <input type="email" class="form-control" id="billing_email"
                                                                                           name="billing_email" v-model="billing.contact_email">
                                                                                </div>
                                                                            </div>
                                                                            <template
                                                                                v-for="(billing_number, contactIndex) in billing.contact_numbers">
                                                                                <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"
                                                                                     v-if="contactIndex == 0">
                                                                                    <div class="form-group cmbne-sel-inpt">
                                                                                        <label>&nbsp;</label>
                                                                                        <div class="add-contact">
                                                                                            <select class="form-control select-control"
                                                                                                    name="billing_phn_type"
                                                                                                    v-model="billing_number.contact_phn_type">
                                                                                                <option value="Mobile">Mobile</option>
                                                                                                <option value="Office">Office</option>
                                                                                            </select>
                                                                                            <validation-provider rules="required"
                                                                                                                 v-slot="{ errors }">
                                                                                                <input type="text" class="form-control contact_no"
                                                                                                       name="billing_phone_no"
                                                                                                       v-model="billing_number.contact_phone_no"/>
                                                                                                <span class="error">{{ errors[0] }}</span>
                                                                                            </validation-provider>
                                                                                            <div class="action-btn">
                                                                                                <div v-if="contactIndex == 0"
                                                                                                     class="btn btn-primary"
                                                                                                     @click="addNewNumberBilling(index)"
                                                                                                     alt="plus-icon"><i
                                                                                                    class="ri-add-circle-line"></i></div>
                                                                                                <a v-if="contactIndex > 0" class="minus-icon"
                                                                                                   @click="removeNumberBlling(index, contactIndex)"
                                                                                                   href="javascript:void(0);"><i
                                                                                                    class="fas fa-minus-circle"></i></a>

                                                                                            </div>
                                                                                        </div>
                                                                                    </div>


                                                                                </div>


                                                                            </template>


                                                                        </div>

                                                                        <div class="contact_row_1 number_row">
                                                                            <div class="row">
                                                                                <template
                                                                                    v-for="(billing_number, contactIndex) in billing.contact_numbers">
                                                                                    <div v-if="contactIndex> 0"
                                                                                         class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                        <div class="contact_row_1 number_row">
                                                                                            <div>
                                                                                                <div class="form-group cmbne-sel-inpt">
                                                                                                    <div class="add-contact">
                                                                                                        <select class="form-control select-control"
                                                                                                                name="contact_phn_type"
                                                                                                                v-model="billing_number.contact_phn_type">
                                                                                                            <option value="Mobile">Mobile</option>
                                                                                                            <option value="Office">Office</option>
                                                                                                        </select>
                                                                                                        <validation-provider rules="required"
                                                                                                                             v-slot="{ errors }">
                                                                                                            <input type="text"
                                                                                                                   class="form-control contact_no"
                                                                                                                   name="contact_phone_no"
                                                                                                                   v-model="billing_number.contact_phone_no"/>
                                                                                                            <span class="error">{{
                                                                                                                    errors[0]
                                                                                                                }}</span>
                                                                                                        </validation-provider>
                                                                                                        <div class="action-btn">
                                                                                                            <div v-if="contactIndex == 0"
                                                                                                                 class="plus-icon"
                                                                                                                 @click="addNewNumberBilling(index)"
                                                                                                                 alt="plus-icon"><i
                                                                                                                class="fas fa-plus"></i></div>
                                                                                                            <a v-if="contactIndex > 0"
                                                                                                               class="btn btn-danger remove"
                                                                                                               @click="removeNumberBlling(index, contactIndex)"
                                                                                                               href="javascript:void(0);"><i
                                                                                                                class="ri-delete-bin-6-line"></i></a>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                </div>
                                                                                            </div>

                                                                                        </div>
                                                                                    </div>

                                                                                </template>
                                                                            </div>
                                                                        </div>

                                                                        <div class="row">


                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <label for="status" class="mdl-textfield__label">Role </label>
                                                                                    <input type="text" v-model="billing.contact_role" name="role"
                                                                                           class="form-control">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                                        <label for="status"
                                                                                               class="mdl-textfield__label">Status </label>
                                                                                        <select class="form-control mdl-textfield__input"
                                                                                                id="status" name="status" v-model="billing.status">
                                                                                            <option value="1">Active</option>
                                                                                            <option value="2">InActive</option>
                                                                                        </select>
                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </validation-provider>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group">
                                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                                        <label for="status" class="mdl-textfield__label">Contact
                                                                                            Type </label>
                                                                                        <select class="form-control mdl-textfield__input"
                                                                                                id="status" name="status"
                                                                                                v-model="billing.contact_type_id">
                                                                                            <option v-for="(contactType) in contactTypes"
                                                                                                    :value="contactType.id">{{ contactType.name }}
                                                                                            </option>
                                                                                        </select>
                                                                                        <span class="error">{{ errors[0] }}</span>
                                                                                    </validation-provider>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group gap-top d-flex">
                                                                                    <input type="checkbox" v-model="billing.default_contact"
                                                                                           name="default" value=""
                                                                                           @change="checkDefaultBilling(index)">
                                                                                    <label for="status" class="mdl-textfield__label">Default
                                                                                        Contact </label>


                                                                                    <div class="action-btn ms-sm-auto">
                                                                                        <a v-if="index > 0" class="remove-icon"
                                                                                           @click="removeContactBilling(index)"
                                                                                           href="javascript:void(0);"><i
                                                                                            class="ri-delete-bin-6-line"></i></a>

                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </template>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>-->
                                            <!--  Billing Contact ends here -->
                                            <!-- Shipping Adress -->

                                            <div class="panel border mb-3">
                                                <div class="card-body">
                                                    <div class="add-container">
                                                        <h2 class="inner-title">Shipping Address</h2>
                                                        <div class="product-create">
                                                            <div id="email_alert1" class="alert alert-danger" style="display: none;">
                                                                <strong>Please fill out * fields</strong>
                                                            </div>
                                                            <div class="plus-iconadd dff-pos" width="25px;"  >
                                                                <button class="btn btn-info  px-3" style="margin-top: -5px" @click="addNewShipping()" alt="plus-icon"><i class="ri-add-circle-line align-middle"></i> Add New</button>
                                                            </div>
                                                            <div class="add_new_contact">
                                                                <template v-for="(shipping_address, index) in form.shipping">




                                                                    <div class="contact-dtlbox">
                                                                        <div class="row count_contact contact_1">
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                                                                <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
                                                                                    <div class="form-group">
                                                                                        <label for="contact_name" class="control-label">Location Name</label>
                                                                                        <input type="text" class="form-control" id="shipping_location" name="shipping_location" v-model="shipping_address.location">
                                                                                        <!-- <span class="error">{{ errors[0] }}</span> -->
                                                                                    </div>

                                                                                <!-- </validation-provider> -->
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                                                                                <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
                                                                                    <GooglePlaceAutoComplete v-if="isModalOpen"
                                                                                                                :title="'Address'"
                                                                                                                :placeholder="'Address'"
                                                                                                               :key="'shipping-'+ index"
                                                                                                                v-model="shipping_address.address"
                                                                                                                                                        @selectedEvent="selectShippingAddress($event, index)"></GooglePlaceAutoComplete>
                                                                                    <!--<div class="form-group">
                                                                                        <label for="contact_email" class="control-label">Address </label>
                                                                                        <input type="text" class="form-control" id="contact_email" name="shipping_address" v-model="shipping_address.address">
                                                                                         <span class="error">{{ errors[0] }}</span>
                                                                                    </div>-->
                                                                                <!-- </validation-provider> -->
                                                                            </div>
                                                                            
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                                                                <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
                                                                                    <div class="form-group">
                                                                                        <label for="contact_email" class="control-label">State </label>
                                                                                        <input type="text" class="form-control" id="shipping_state" name="shipping_state" v-model="shipping_address.state">
                                                                                        <!-- <span class="error">{{ errors[0] }}</span> -->
                                                                                    </div>
                                                                                <!-- </validation-provider> -->
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                                                                <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
                                                                                    <div class="form-group">
                                                                                        <label for="contact_email" class="control-label">City </label>
                                                                                        <input type="text" class="form-control" id="shipping_city" name="shipping_city" v-model="shipping_address.city">
                                                                                        <!-- <span class="error">{{ errors[0] }}</span> -->
                                                                                    </div>
                                                                                <!-- </validation-provider> -->
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-2">
                                                                                <!-- <validation-provider rules="required" v-slot="{ errors }"> -->
                                                                                    <div class="form-group">
                                                                                        <label for="contact_email" class="control-label">Zip </label>
                                                                                        <input type="text" class="form-control" id="shipping_zip" name="shipping_zip" v-model="shipping_address.zip">
                                                                                        <!-- <span class="error">{{ errors[0] }}</span> -->
                                                                                    </div>
                                                                                <!-- </validation-provider> -->
                                                                            </div>
                                                                            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
                                                                                <div class="form-group gap-top d-flex">
                                                                                    <input type="checkbox" v-model="shipping_address.default_contact" name="default_contact" value="" @change="checkDefaultShipping(index)" >
                                                                                    <label for="status" class="mdl-textfield__label">Default address </label>



                                                                                </div>
                                                                                <div class="action-btn ms-sm-auto">
                                                                                    <a v-if="index > 0" class="remove-icon" @click="removeContactShipping(index)"  href="javascript:void(0);" ><i class="ri-delete-bin-6-line"></i></a>
                                                                                </div>
                                                                            </div>


                                                                        </div>


                                                                    </div>
                                                                </template>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Shipping Adress -->

                                            <div class="panel border mb-3">
                                                <div class="card-body">
                                                    <div class="add-container">
                                                        <h2 class="inner-title">Other</h2>
                                                        <div class="row">
                                                            <div class="col-lg-8 col-md-8">
                                                                <div class="form-group">
                                                                    <label>About the Customer</label>
                                                                    <textarea rows="4" class="form-control" v-model="form.about_us" placeholder=""></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-8 col-md-8">
                                                                <div class="form-group">
                                                                    <label>SO Note</label>
                                                                    <textarea rows="4" class="form-control" v-model="form.customer_so_note" placeholder=""></textarea>
                                                                </div>
                                                            </div>

                                                            <div class="col-lg-8 col-md-8">
                                                                <div class="form-group">
                                                                    <label>Payment Terms</label>
                                                                    <textarea rows="4" class="form-control" v-model="form.customer_payment_terms" placeholder=""></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="col-lg-8 col-md-8">
                                                                <div class="form-group">
                                                                    <label>Stocking Terms</label>
                                                                    <textarea rows="4" class="form-control" v-model="form.stocking_terms" placeholder=""></textarea>
                                                                </div>
                                                            </div>




                                                            <div class="col-lg-4 col-md-4">

                                                                <div class="form-group">
                                                                    <validation-provider rules="required" v-slot="{ errors }">
                                                                        <label for="status" class="mdl-textfield__label1">Status *</label>
                                                                        <select class="form-control mdl-textfield__input" id="ship_status" name="status" v-model="form.status">
                                                                            <option value="1">Active</option>
                                                                            <option value="2">InActive</option>
                                                                        </select>
                                                                        <span>{{ errors[0] }}</span>
                                                                    </validation-provider>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="btnrow text-right">
                                        <button type="button" class="btn btn-danger" data-dismiss="modal" aria-hidden="true">Cancel</button>
                                        <!-- <router-link :to="{name: 'viewCustomers'}" class="btn skip-btn">Discard</router-link> -->
                                        <button type="submit" class="btn custom-btn ml-1" id="save_customer_btn">Save</button>
                                        <!-- <a href="#" class="btn custom-btn ml-3">Save</a> -->
                                    </div>
                                </div>
                            </form>
                        </ValidationObserver>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationObserver,ValidationProvider, extend,validate  } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import GooglePlaceAutoComplete from "./GooglePlaceAutoComplete";

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

// with typescript
for (let [rule, validation] of Object.entries(rules)) {
    extend(rule, {
        ...validation
    });
}
export default {
    name: "CustomerAdd",
    components: {
        ValidationProvider,ValidationObserver,
        GooglePlaceAutoComplete,
    },
    props: [ 'bus'],
    created() {
        /*this.getCountries();
        this.getSalesRep();
        this.setSuccessMessage(null);*/
    },
    mounted() {
        let self = this;
        $(this.$refs.customerAddModal).on('show.bs.modal', () => {
            self.isModalOpen = true;
            self.getCountries();
            self.getSalesRep();
            self.getContactTypes();
            self.setSuccessMessage(null);
        });

        $(this.$refs.customerAddModal).on('hide.bs.modal', () => {
            self.isModalOpen = false;
        });
    },
    data(){
        return {
            po_box:false,
            isModalOpen: false,
            countries: [],
            salesRep: {
                data:[]
            },
            contactTypes: [],
            form: {
                id: null,
                customer_so_note:null,
                purchase_terms:null,
                customer_payment_terms:null,
                stocking_terms:null,
                company_name: null,
                address: null,
                country_id: null,
                website: null,
                fax: null,
                sales_rep_id:'',
                phone:null,
                email:null,
                contacts: [
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status: 1,
                        default_contact:true,
                        contact_role:null,
                        contact_type_id: 1,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                shipping:[
                    {
                        location:null,
                        address:null,
                        state:null,
                        city:null,
                        zip:null,
                        default_contact:true
                    }
                ],
                billing:[
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status:null,
                        default_contact:true,
                        contact_type_id:null,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_role:null,
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                about_us: null,
                status: 1,
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading'
        ]),
        checkStatus(e) {
        this.po_box = e.target.checked
            ? true
            : false;
           // alert(this.po_box);
        },
        selectCompanyAddress(place){
            let country = place.address_components.find((x) => x.types.includes('country'));

            if(country) {
                let selectedCountry = this.countries.find((x) => x.code === country.short_name);
                if(selectedCountry) {
                    this.form.country_id = selectedCountry.id;
                }
            }

            /*if(place.name != '') {
                this.form.address = place.formatted_address;
            }
            else{
                this.form.address = place.formatted_address;
            }*/

            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            //let country = place.address_components.find((x) => x.types.includes('country'));
            //console.log("locality",locality);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
               
                this.form.address = place.name;
            }
            else{
                
                this.form.address = address;
            }

            this.form.post_code = null;
            if(pinCode) {
                this.form.post_code = pinCode.long_name;
            }
            this.form.city = null;
           
            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.city = neighborhood.long_name;
               
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.city = locality.long_name;
               
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.city = city.long_name;
                
            }
            this.form.state = null;
            if(state) {
                this.form.state = state.short_name;
            }
           // console.log("this.form.shipping[index]",this.form.shipping);
        },
        selectShippingAddress(place, index){
            
        //alert("ddd"+index);
            let lat = place.geometry.location.lat();
            let lng = place.geometry.location.lng();
            let neighborhood = place.address_components.find((x) => x.types.includes('neighborhood'));
            let sublocality = place.address_components.find((x) => x.types.includes('sublocality'));
            let locality = place.address_components.find((x) => x.types.includes('locality'));
            let pinCode = place.address_components.find((x) => x.types.includes('postal_code'));
            let state = place.address_components.find((x) => x.types.includes('administrative_area_level_1'));
            let city = place.address_components.find((x) => x.types.includes('administrative_area_level_3'));
            let country = place.address_components.find((x) => x.types.includes('country'));
            //console.log("locality",locality);
            let address = '';
            if(neighborhood) {
                address += neighborhood.long_name;
            }
            if(sublocality) {
                address += address.length > 0 ?', ' : '';
                address += sublocality.long_name;
            }
            if(locality) {
                address += address.length > 0 ?', ' : '';
                address += locality.long_name;
            }

            if(address == '') {
                address = place.formatted_address;
            }

            if(place.name != '') {
                if(!this.form.shipping[index].address2 || this.form.shipping[index].address2 === ''){
                   // this.form.shipping[index].address2 = place.name;
                }
                //this.form.shipping[index].address = place.name+' , '+place.formatted_address;
                //alert("place.name"+place.name);
                this.form.shipping[index].address = place.name;
            }
            else{
                //alert('ddd');
                //this.form.shipping[index].address = place.formatted_address;
                this.form.shipping[index].address = address;
            }

            this.form.shipping[index].post_code = null;
            this.form.shipping[index].zip = null;
            if(pinCode) {
                this.form.shipping[index].post_code = pinCode.long_name;
                this.form.shipping[index].zip =  pinCode.long_name;
            }
            this.form.shipping[index].city = null;
            // if(locality) {
            //     console.log("city",locality);
            //     this.form.shipping[index].city = locality.long_name;
            //     console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            // }
            // if(city) {
            //     console.log("city",locality);
            //     this.form.shipping[index].city = city.long_name;
            //     console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            // }
            if(neighborhood) {
                console.log("city",neighborhood);
                this.form.shipping[index].city = neighborhood.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood && locality) {
                console.log("city",locality);
                this.form.shipping[index].city = locality.long_name;
               // console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            if(!neighborhood &&  !locality && city) {
                console.log("city",locality);
                this.form.shipping[index].city = city.long_name;
                //console.log("this.form.shipping[index].city",this.form.shipping[index].city);
            }
            this.form.shipping[index].state = null;
            if(state) {
                this.form.shipping[index].state = state.short_name;
            }
            console.log("this.form.shipping[index]",this.form.shipping);

        },
        onContactTypeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        onContactTypeDeSelect(event, index){
            console.log(event)
            this.form.contacts[index].contact_type_ids = [];
            if (event) {
                event.forEach((x) => {
                    this.form.contacts[index].contact_type_ids.push(x.id);
                })
            }
        },
        save() {

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('customers.store'), this.form,{
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                        //console.log("Errors ",this.commonErrors);
                        for(var i = 0;i< this.commonErrors.length;i++){
                            //console.log("Errors inside ");
                        }
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.customerData = data.data;
                        self.$emit('customerDataSaved', data.data);


                        self.setSuccessMessage("Customer added successfully.");
                        this.reset();
                        setTimeout(() => {

                            $('#customerAddModal').modal('hide');
                            self.setSuccessMessage(null);
                        }, 3500);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        addNewContact() {
            let firstTypes = this.contactTypes.filter((x) => x.id == 1);

            this.form.contacts.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                status: 1,
                default_contact:true,
                contact_role:null,
                contact_type_id: 1,
                contact_type_ids:[1],
                contact_types: firstTypes,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

            console.log(this.form.contacts.length);

        },
        addNewContactBilling() {
            this.form.billing.push({
                contact_id: null,
                contact_name: null,
                contact_email: null,
                contact_numbers: [
                    {
                        contact_phn_type: 'Mobile',
                        contact_phone_no: null,
                    }
                ]
            });

            console.log(this.form.billing.length);

        },
        addNewShipping(){
            this.form.shipping.push({
                location: null,
                address: null,
                state: null,
                city: null,
                zip: null,
                default_contact:false
            });

            console.log(this.form.shipping.length);
        },
        checkDefault(defIndex,event){
            this.form.contacts.forEach((value, index) => {
                if(defIndex == index){
                    this.form.contacts[index].default_contact = true;
                }
                else{
                    this.form.contacts[index].default_contact = false;
                }
            });
        },
        checkDefaultBilling(defIndex,event){
            this.form.billing.forEach((value, index) => {
                if(defIndex == index){
                    this.form.billing[index].default_contact = true;
                }
                else{
                    this.form.billing[index].default_contact = false;
                }
            });
        },

        checkDefaultShipping(defIndex,event){
            this.form.shipping.forEach((value, index) => {
                if(defIndex == index){
                    this.form.shipping[index].default_contact = true;
                }
                else{
                    this.form.shipping[index].default_contact = false;
                }
            });
        },
        removeContact(index){
            this.form.contacts.splice(index, 1);
        },
        removeContactBilling(index){
            this.form.billing.splice(index, 1);
        },
        removeContactShipping(index){
            this.form.shipping.splice(index, 1);
        },
        addNewNumber(index) {
            this.form.contacts[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
        },
        addNewNumberBilling(index) {
            this.form.billing[index].contact_numbers.push({
                contact_phn_type: 'Mobile',
                contact_phone_no: null,
            });
        },
        removeNumber(index, contactIndex) {
            this.form.contacts[index].contact_numbers.splice(contactIndex, 1);
        },
        removeNumberBlling(index, contactIndex) {
            this.form.billing[index].contact_numbers.splice(contactIndex, 1);
        },
        async reset() {
            this.form =  {
                id: null,
                customer_so_note:null,
                purchase_terms:null,
                customer_payment_terms:null,
                stocking_terms:null,
                company_name: null,
                address: null,
                country_id: null,
                website: null,
                fax: null,
                sales_rep_id:'',
                phone:null,
                email:null,
                contacts: [
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status: 1,
                        default_contact:true,
                        contact_role:null,
                        contact_type_id: 1,
                        contact_type_ids:[1],
                        contact_types: [],
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                shipping:[
                    {
                        location:null,
                        address:null,
                        state:null,
                        city:null,
                        zip:null,
                        default_contact:true
                    }
                ],
                billing:[
                    {
                        contact_id: null,
                        contact_name: null,
                        contact_email: null,
                        status:null,
                        default_contact:true,
                        contact_type_id:null,
                        contact_type_ids:[1],
                        contact_role:null,
                        contact_numbers: [
                            {
                                contact_phn_type: 'Mobile',
                                contact_phone_no: null,
                            }
                        ]
                    }
                ],
                about_us: null,
                status: 1,
            };
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        getCountries() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('countries.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.countries = data.data.countries;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSalesRep() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('sales-reps.index'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.salesRep = data.data.saleUsers;

                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getContactTypes() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('getContactTypes'), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors && data.errors.length){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.contactTypes = data.data;

                        let firstTypes = this.contactTypes.filter((x) => x.id == 1);

                        this.form.contacts.forEach((contact) => {
                            contact.contact_types = firstTypes;
                        })
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);
                })
                .finally(() => {
                    self.setCustomerLoading(false);
                });
        },
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>
.vs__selected {
    z-index: 3 !important;
}
.modal-dialog .vs__selected-options .vs__search {
    width: 0px !important;
}
</style>
